const colors = {
  brand: {
    purple: '#49007E',
    red: '#fd2f3f',
    yellow: '#FFBD00'
  }
};

export default colors.brand;
